module.exports = __webpack_public_path__ + "static/media/text-extra.12fed842.svg";